"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var Observable_1 = require("rxjs/Observable");
require("rxjs/add/observable/zip");
/**
 * This guards prevents user from navigating to
 * login page if he/she is already logged in.
 * */
var LoginPagePreventionGuard = /** @class */ (function () {
    function LoginPagePreventionGuard(authenticationService, router) {
        this.authenticationService = authenticationService;
        this.router = router;
    }
    LoginPagePreventionGuard.prototype.canActivate = function (route, state) {
        var _this = this;
        var loginObservable = Observable_1.Observable.zip(this.authenticationService.isLoggedOn(), this.authenticationService.isLoggedOnAsGuestUser());
        return loginObservable
            .map(function (_a) {
            var isLogged = _a[0], isGuest = _a[1];
            if (isLogged && !isGuest) {
                _this.router.navigate(['/']);
                return false;
            }
            return true;
        })
            .take(1);
    };
    LoginPagePreventionGuard = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.AuthenticationService, router_1.Router])
    ], LoginPagePreventionGuard);
    return LoginPagePreventionGuard;
}());
exports.LoginPagePreventionGuard = LoginPagePreventionGuard;
//# sourceMappingURL=login-page-prevention-guard.js.map